<template>
  <ResponsiveConfirmDialog
    :show="show"
    :title="__(`${uppercaseMode} Resource`)"
    role="alertdialog"
    size="sm"
    @close="handleClose"
    @close-via-escape="handleClose"
  >
    <form
      @submit.prevent="handleConfirm"
      class="panel-confirm-dialog max-md:!bg-transparent overflow-hidden rounded-3xl border border-zinc-200/70 bg-white shadow-2xl dark:border-zinc-800 dark:bg-zinc-900 dark:max-md:!bg-transparent max-md:rounded-none max-md:border-0 max-md:shadow-none"
    >
      <slot>
        <ModalHeader class="max-md:hidden" v-text="__(`${uppercaseMode} Resource`)" />
        <ModalContent>
          <p class="leading-relaxed" v-if="reasonForConditionalDeletion == ''">
            {{
              __(
                'Are you sure you want to ' + mode + ' the selected resources?'
              )
            }}
          </p>
          <p v-else>
            {{ reasonForConditionalDeletion }}
          </p>
        </ModalContent>
      </slot>

      <ModalFooter v-if="reasonForConditionalDeletion == ''" class="max-md:hidden">
        <div class="panel-confirm-footer-actions ml-auto flex w-full items-center">
          <LinkButton
            type="button"
            dusk="cancel-delete-button"
            class="mr-3"
            @click.prevent="handleClose"
          >
            {{ __('Cancel') }}
          </LinkButton>

          <Button
            type="submit"
            ref="confirmButton"
            dusk="confirm-delete-button"
            :loading="working"
            state="danger"
            :label="__(uppercaseMode)"
          />
        </div>
      </ModalFooter>
    </form>

    <template v-if="reasonForConditionalDeletion == ''" #footer>
      <form class="w-full" @submit.prevent="handleConfirm">
        <div class="panel-confirm-footer-actions panel-confirm-footer-actions--sheet">
          <LinkButton
            type="button"
            class="flex-1 justify-center"
            dusk="cancel-delete-button"
            @click.prevent="handleClose"
          >
            {{ __('Cancel') }}
          </LinkButton>

          <Button
            type="submit"
            class="flex-1"
            dusk="confirm-delete-button"
            :loading="working"
            state="danger"
            :label="__(uppercaseMode)"
          />
        </div>
      </form>
    </template>
  </ResponsiveConfirmDialog>
</template>

<script>
import startCase from 'lodash/startCase'
import { Button } from 'laravel-nova-ui'

export default {
  components: {
    Button,
  },

  emits: ['confirm', 'close'],

  props: {
    show: { type: Boolean, default: false },
    reasonForConditionalDeletion: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: 'delete',
      validator: function (value) {
        return ['force delete', 'delete', 'detach'].indexOf(value) !== -1
      },
    },
  },

  data: () => ({
    working: false,
  }),

  watch: {
    show(showing) {
      if (showing === false) {
        this.working = false
      }
    },
  },

  methods: {
    handleClose() {
      this.$emit('close')
      this.working = false
    },

    handleConfirm() {
      this.$emit('confirm')
      this.working = true
    },
  },

  mounted() {
    this.$nextTick(() => {
      // this.$refs.confirmButton.button.focus()
    })
  },

  computed: {
    uppercaseMode() {
      return startCase(this.mode)
    },
  },
}
</script>
